import React from "react";
import { Card as MantineCard, CardProps } from "@mantine/core";

interface CustomCardProps
  extends Omit<CardProps, "styles">,
    Omit<React.HTMLAttributes<HTMLDivElement>, "style"> {
  glass?: boolean;
}

const CardComponent: React.FC<CustomCardProps> = ({ glass = true, ...props }) => {
  return (
    <MantineCard
      {...props}
      styles={{
        root: {
          backgroundColor: glass ? "rgba(18,18,18,0.55)" : "rgba(18,18,18,0.9)",
          backdropFilter: glass ? "blur(20px) saturate(180%)" : undefined,
          WebkitBackdropFilter: glass ? "blur(20px) saturate(180%)" : undefined,
          border: "1px solid rgba(212,85,43,0.12)",
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.07), 0 8px 32px rgba(0,0,0,0.4)",
          transition: "all 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
        },
      }}
    />
  );
};

(
  CardComponent as typeof CardComponent & {
    Section: typeof MantineCard.Section;
  }
).Section = MantineCard.Section;

export const Card = CardComponent as typeof CardComponent & {
  Section: typeof MantineCard.Section;
};
export default Card;
